import 'consumer-mobile-web/screens/Survey/Mobile'
import Survey from 'consumer-mobile-web/screens/Survey'
import 'consumer-mobile-web/logging/rollbarConfigure'
import 'shared/utils/polyfills'
import renderToDOM from 'shared/applicationRenderer'
import {
  clearAllAuthTokens,
  getAuthToken,
  getJobIdForToken,
  setAuthToken,
} from 'consumer-mobile-web/utils/sessionToken'
import datadog from 'shared/utils/logging/integrations/datadog'

const existingAuthToken = getAuthToken()
const jobIdForToken = getJobIdForToken()
const surveyAuthLogContext = {
  has_existing_auth_token: Boolean(existingAuthToken),
  has_gon: Boolean(window.gon),
  has_legacy_review_token: Boolean(window.gon?.token),
  has_review_ssid: Boolean(window.gon?.review_ssid),
  job_id_for_token: jobIdForToken,
  survey_path: window.location.pathname,
}

if (window.gon?.mobile_web_job_token) {
  if (jobIdForToken) {
    setAuthToken(window.gon.mobile_web_job_token)
    datadog.logInfo('survey auth seeded current job token before render', {
      ...surveyAuthLogContext,
      replaced_existing_auth_token:
        Boolean(existingAuthToken) && existingAuthToken !== window.gon.mobile_web_job_token,
    })
  } else {
    datadog.logError('survey auth token present but job ID unresolvable', surveyAuthLogContext)
  }
} else if (existingAuthToken) {
  clearAllAuthTokens()
  datadog.logWarning(
    'survey auth missing gon token and cleared stored auth tokens',
    surveyAuthLogContext
  )
} else {
  datadog.logWarning('survey auth missing gon token before render', surveyAuthLogContext)
}

renderToDOM(<Survey />)
